import React from 'react'
import styled from 'styled-components'
import scale from '../constants/scale'
import color from '../constants/colors'
import QuoteContainer from '../components/QuoteContainer'
import { ReactComponent as AppleButton} from '../img/download-on-the-app-store-badge-us-uk-rgb-blk-092917.svg';
import { ReactComponent as GoogleButton} from '../img/google-play-badge@1x.svg';
import {
    isBrowser,
    isAndroid,
    isIOS,
  } from "react-device-detect";

const LandingPage = () => {
    return (
        <Page>
            <SectionOne src="assets/landing-phone-min.jpg" srcMobile="assets/landing-phone-min-mobile.jpg"> 
                <Logo alt="logo" src="/assets/logo-doneski.svg" />
                <Wrapper>
                    <LandingContent>
                        <HelloContent>
                            <InfoBox>
                                <Content>
                                    <LogoMobile alt="logo" src="/assets/logo-doneski-final.svg" />
                                    <Text 
                                    fontSize={'22px'} 
                                    fontWeight={'900'} 
                                    letterSpacing={'-0.53px'} 
                                    color={color.BLACK}
                                    fontFamily={'Maven Pro'}
                                    >You Snap it, they’ll do it!</Text>
                                    <Space height={'4px'} />
                                    <Text 
                                    fontSize={'21px'} 
                                    fontWeight={'500'} 
                                    letterSpacing={'-0.5px'} 
                                    color={color.BLACK}
                                    fontFamily={'Maven Pro'}
                                    >Wanted. A good local Tradie. Indroducing the new Instagram of Tradie Apps!</Text>
                                </Content>
                            </InfoBox>
                            <ButtonContainer>
                                { isBrowser &&
                                    <ButtonApp href="https://apps.apple.com/gb/app/doneski-australia/id1488205624?ign-mpt=uo%3D2">
                                        <PhoneLogo alt="apple" src="/assets/apple-logo.svg"/>
                                        <Text
                                        fontSize={'22px'} 
                                        fontWeight={'normal'} 
                                        letterSpacing={'-0.53px'} 
                                        color={color.WHITE}
                                        fontFamily={'Lato'}
                                        >Get the app</Text>
                                    </ButtonApp>
                                }
                                { isBrowser &&
                                    <ButtonApp href="https://play.google.com/store/apps/details?id=com.doneski_rn">
                                        <PhoneLogo alt="android" src="/assets/google-play-logo.svg"/>
                                        <Text
                                        fontSize={'22px'} 
                                        fontWeight={'normal'} 
                                        letterSpacing={'-0.53px'} 
                                        color={color.WHITE}
                                        fontFamily={'Lato'}
                                        >Get the app</Text>
                                    </ButtonApp>
                                }
                                { isIOS &&
                                    <ButtonApp href="https://apps.apple.com/gb/app/doneski-australia/id1488205624?ign-mpt=uo%3D2">
                                        <PhoneLogo alt="apple" src="/assets/apple-logo.svg"/>
                                        <Text
                                        fontSize={'22px'} 
                                        fontWeight={'normal'} 
                                        letterSpacing={'-0.53px'} 
                                        color={color.WHITE}
                                        fontFamily={'Lato'}
                                        >Get the app</Text>
                                    </ButtonApp>
                                }
                                { isAndroid  &&
                                    <ButtonApp href="https://play.google.com/store/apps/details?id=com.doneski_rn">
                                        <PhoneLogo alt="android" src="/assets/google-play-logo.svg"/>
                                        <Text
                                        fontSize={'22px'} 
                                        fontWeight={'normal'} 
                                        letterSpacing={'-0.53px'} 
                                        color={color.WHITE}
                                        fontFamily={'Lato'}
                                        >Get the app</Text>
                                    </ButtonApp>
                                }
                            </ButtonContainer>
                        </HelloContent>
                    </LandingContent>
                </Wrapper>
            </SectionOne>

            <SectionTwo>
                <Wrapper>
                    <Space height={'122px'} mobileHeight={'103px'} />
                    <Flex>
                        <Title 
                        fontSize={'36px'} 
                        fontWeight={'900'} 
                        letterSpacing={'-0.86px'} 
                        color={color.BLACK}
                        fontFamily={'Lato'}
                        fontSizeMobile={'28px'}
                        marginMobile={'70px'}
                        >Get it done with DoneSki. It's Easy!</Title>
                    </Flex>
                    <Space height={'64px'} />
                    <FlexCenter>
                        <StepContainer>
                            <Img src="/assets/step-one.png"/>
                            <Space height={'14px'} />
                            <Text 
                            fontSize={'24px'} 
                            fontWeight={'bold'} 
                            letterSpacing={'-0.58px'} 
                            color={color.PINKRED}
                            fontFamily={'Nunito Sans'}
                            >STEP 1</Text>
                            <Text 
                            fontSize={'24px'} 
                            fontWeight={'normal'} 
                            letterSpacing={'-0.58px'} 
                            color={color.BLACK}
                            fontFamily={'Nunito Sans'}
                            >Tap “Get it DoneSki”</Text>
                        </ StepContainer>
                        <StepContainer>
                            <Img src="/assets/step-two.png"/>
                            <Space height={'14px'} />
                            <Text 
                            fontSize={'24px'} 
                            fontWeight={'bold'} 
                            letterSpacing={'-0.58px'} 
                            color={color.PINKRED}
                            fontFamily={'Nunito Sans'}
                            >STEP 2</Text>
                            <Text 
                            fontSize={'24px'} 
                            fontWeight={'normal'} 
                            letterSpacing={'-0.58px'} 
                            color={color.BLACK}
                            fontFamily={'Nunito Sans'}
                            >Take a photo</Text>
                        </ StepContainer>
                        <StepContainer>
                            <Img src="/assets/step-three.png"/>
                            <Space height={'14px'} />
                            <Text 
                            fontSize={'24px'} 
                            fontWeight={'bold'} 
                            letterSpacing={'-0.58px'} 
                            color={color.PINKRED}
                            fontFamily={'Nunito Sans'}
                            >STEP 3</Text>
                            <Text 
                            fontSize={'24px'} 
                            fontWeight={'normal'} 
                            letterSpacing={'-0.58px'} 
                            color={color.BLACK}
                            fontFamily={'Nunito Sans'}
                            >Add details and post. DoneSki!</Text>
                        </ StepContainer>
                    </FlexCenter>
                </ Wrapper>
                <Space height={'116px'} />
            </SectionTwo> 
            <SectionThree>
                <Space height={'80px'} />
                <Wrapper>
                    <FlexQuote>
                        <QuoteContainer 
                        quote={'“..they’ve introduced a new and easy way to hire local tradies..” '} 
                        author={'Trustworthy real estate agent'}/>
                        <QuoteContainer 
                        quote={'"..we don’t pay any rip off fees, it’s not a scam where I pay to quote, at last someone got it right.." '} 
                        author={'Bright sparkie'}/>
                        <QuoteContainer 
                        quote={'“..I’m going to stock up on toilet paper with the time and money I saved on DoneSki..”'} 
                        author={'Victorian - in the place not to be'}/>
                        <QuoteContainer 
                        quote={'“..I didn’t realise I was ripping off the people doing the work..”'} 
                        author={'Fake tradie app lead'}/>
                        <QuoteContainer 
                        quote={'“..I charge high fees to the poster and the worker, sipping latte’s costs money..”'} 
                        author={'Anonymous software developer'}/>
                        <QuoteContainer 
                        quote={'“..That’s my number 04***, and my business name is ***, I’ll come visit to quote properly..”'} 
                        author={'Banned worker'}/>
                        <QuoteContainer 
                        quote={'“..Before DoneSki I used to gamble paying to quote, now I have more money for Sportsbet..” '} 
                        author={'Brickie who loves a punt'}/>
                    </FlexQuote>
                    <Space height={'130px'} mobileHeight={'71px'}/>
                    <Flex>
                        <Title 
                        fontSize={'36px'} 
                        fontWeight={'900'} 
                        letterSpacing={'-0.86px'} 
                        color={color.BLACK}
                        fontSizeMobile={'28px'}
                        marginMobile={'30px'}
                        >Get the App, Get it DoneSki</Title>
                    </Flex>
                    <Space height={'32px'} mobileHeight={'20px'}/>
                    <Flex>
                        <div>
                            <a href="https://apps.apple.com/gb/app/doneski-australia/id1488205624?ign-mpt=uo%3D2">
                                <AppleButton />
                            </a>
                        </div>

                        <div>
                            <a href="https://play.google.com/store/apps/details?id=com.doneski_rn">
                                <GoogleButton />
                            </a>
                        </div>
                    </Flex>    
                    <Space height={'113px'} mobileHeight={'152px'}/>           
                </ Wrapper>
            </SectionThree>
            <Footer>
                <Space height={'42px'} mobileHeight={'32px'}/>
                <Wrapper>
                    <FooterContent>
                        <FootInfoBox>
                            <FootLogo alt="logo" src="/assets/logo-doneski.svg" />
                            <Space height={'29.5px'}/>
                            <LinkContainer>
                                <LinkColumnOne>
                                    <Link href="mailto:feedback@doneski.com.au">Contact us</Link>
                                    <Link href="https://app.termly.io/document/privacy-policy/67eee10b-8b0b-450e-8f86-1d5249f8ffe9">Privacy Policy</Link>
                                    <Link href="https://app.termly.io/document/terms-and-conditions/d785e751-5dbf-4158-94a8-b472b5c7f1df">Terms</Link>
                                </LinkColumnOne>
                                <LinkColumnTwo>
                                    <LinkBox>
                                        <a href="https://www.instagram.com/doneskiaustralia/?hl=en">
                                            <SocialLogoInsta alt="logo" src="/assets/instagram.svg" /> 
                                        </a>
                                        <LinkSocial href="https://www.instagram.com/doneskiaustralia/?hl=en">Instagram</LinkSocial>
                                    </LinkBox>
                                    <LinkBox>
                                        <a href="https://www.facebook.com/DoneSki-103043704622514">
                                            <SocialLogoFb alt="logo" src="/assets/facebook.svg" /> 
                                        </a>
                                        <LinkSocial href="https://www.facebook.com/DoneSki-103043704622514">Facebook</LinkSocial>
                                    </LinkBox>
                                </LinkColumnTwo>
                            </LinkContainer>
                        </FootInfoBox>
                        <DownloadButtons>
                            <div>
                                <a href="https://play.google.com/store/apps/details?id=com.doneski_rn">
                                    <GoogleButton />
                                </a>
                            </div>
                            <div>
                                <a href="https://apps.apple.com/gb/app/doneski-australia/id1488205624?ign-mpt=uo%3D2">
                                    <AppleButton />
                                </a>
                            </div>
                        </DownloadButtons>
                    </FooterContent>
                    <Space height={'39.5px'} mobileHeight={'113.5px'}/>
                    <Flex>
                        <Text 
                        fontSize={'12px'} 
                        fontWeight={'normal'} 
                        letterSpacing={'-0.29px'} 
                        color={color.WHITE}
                        >©Copyright 2020 DoneSki Australia PTY LTD,</Text>
                    </Flex>
                    <Flex>
                        <Text 
                        fontSize={'12px'} 
                        fontWeight={'normal'} 
                        letterSpacing={'-0.29px'} 
                        color={color.WHITE}
                        >ABN: 86 636 781 738. All rights reserved.</Text>
                    </Flex>
                    <Space height={'16px'}/>
                </Wrapper>    
            </Footer>
        </Page>
    )
}

export default LandingPage

const Page = styled.div`
  
`
const ButtonContainer = styled.div`
    display: flex;
`
const PhoneLogo = styled.img`
    margin-right: 12px;
`
const DownloadButtons = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    ${scale.FULLWIDHMAX} {
        margin-right: 31px;
    }
    ${scale.MOBILE} {
        display: none;
    }
`
const FooterContent = styled.div`
    display:flex;
    justify-content: Space-between;
`
const SocialLogoInsta = styled.img`
    margin-right: 19px;
`
const SocialLogoFb = styled.img`
    margin-right: 24px;
    margin-left: 5px;
`
const FootInfoBox = styled.div`
    ${scale.FULLWIDHMAX} {
        margin-left: 31px;
    }
`
const LinkBox = styled.div`
    display: flex;
    margin-top: 6.5px;
    margin-bottom: 6.5px;
`
const LinkColumnOne = styled.div`
    display: flex;
    flex-direction: column;
`
const LinkColumnTwo = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 82px;
    ${scale.MOBILE} {
        margin-left: 0px;
        flex-direction: row;
        margin-top: 34.5px;
    }
`
const Link = styled.a`
    color: ${color.WHITE};
    margin-top: 6.5px;
    margin-bottom: 6.5px;
    &:hover {
        color: ${color.PINKRED};
      }
`
const LinkSocial = styled.a`
    color: ${color.WHITE};
    ${scale.MOBILE} {
        display: none;
    }
    &:hover {
        color: ${color.PINKRED};
      }
`
const LinkContainer = styled.div`
    display: flex;
    ${scale.MOBILE} {
        flex-direction: column;
    }
`
const Footer = styled.div`
    background-color: ${color.DEEPGREY};

`
const Flex = styled.div`
    display: flex;
    justify-content: center;
`
const FlexQuote = styled.div`
    display: flex;
    justify-content: Space-between;
    flex-wrap: wrap;
    @media (max-width: 1200px) {
        justify-content: center;
    }
`

const Img = styled.img`
    width: 100%;
`

const FootLogo = styled.img`
    max-width: 118px;
`

const FlexCenter = styled.div`
    display: flex;
    justify-content: Space-between;
    width: 100%;
    ${scale.MOBILE} {
        flex-direction: column;
        align-items: center;
    }
`

const StepContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 376px;
    ${scale.MOBILE} {
        margin-top: 61px;
    }
`


const Space = styled.div`
    height: ${props => props.height};
    ${scale.MOBILE} {
        height: ${props => props.mobileHeight};
    }
`

const Title = styled.h1`
    font-size: ${props => props.fontSize};
    font-weight: ${props => props.fontWeight};
    letter-spacing: ${props => props.letterSpacing};
    color: ${props => props.color};
    margin: 0px;
    ${scale.MOBILE} {
        font-size: ${props => props.fontSizeMobile};
        margin-left: ${props => props.marginMobile};
        margin-right: ${props => props.marginMobile};
        text-align: center;
    }
`

const Text = styled.p`
    font-size: ${props => props.fontSize};
    font-weight: ${props => props.fontWeight};
    letter-spacing: ${props => props.letterSpacing};
    color: ${props => props.color};
    margin: 0px;
    font-family: ${props => props.fontFamily};
`

const ButtonApp = styled.a`
    width: 207px;
    height: 57px;
    background-color: ${color.PINKRED};
    display: flex;
    justify-content: center;   
    align-items: center;
    margin-left: 8px;
    text-decoration: none;
`

const Wrapper = styled.div`
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
`
const Content = styled.div`
    margin-left: 25px;
    margin-top: 20px;
    margin-bottom: 45px;
    margin-right: 10px;
    ${scale.MOBILE} {
        margin-left: 16px;
        margin-top: 16px;
        margin-bottom: 21px;
    }
`
const LandingContent = styled.div`
    display: flex;
    justify-content: flex-end;
`
const HelloContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`

const InfoBox = styled.div`
    margin-top: 325px;
    width: 549px;
    background-color: ${color.GREY};
    ${scale.MOBILE} {
        margin-top: 55vh;
        width: 345px;
    }
`
const Logo = styled.img`
    margin-left: 66px;
    margin-top: 33px;
    ${scale.MOBILE} {
        display:none
      }
`
const LogoMobile = styled.img`
      display: none;
    ${scale.MOBILE} {
        display: initial;
      }
`

const SectionOne = styled.div`
  width: 100%;
  height: 90vh;
  background-color: transparent;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  min-height: 650px;
  ${scale.MOBILE} {
    height: 80vh;
    min-height: 300px;
    background-position: 35% center;
    background-image: url(${props => props.srcMobile});
  }
`

const SectionTwo = styled.div`
  background-color: ${color.DARKGREY};
  width: 100%;
  ${scale.MOBILE} {
   
  }
`

const SectionThree = styled.div`
  background-color: ${color.white};
  width: 100%;
  ${scale.MOBILE} {
   
  }
`
